import { ColumnExport } from '@app/shared/export';
import { ExportService } from '@app/shared/export/export.service';
import { StringMap } from '@app/utils/string-map';

export class ExportBuilder<T> {
  private columns: ColumnExport<T>[] = [];

  constructor(
    private data: T[],
    private exportService: ExportService
  ) {}

  public addColumn(options: ColumnExport<T>): this {
    this.columns.push(options);

    return this;
  }

  public export(fileName: string, fileNameParameters?: StringMap<string>): void {
    this.exportService.export(this.data, this.columns, fileName, fileNameParameters);
  }
}
